export enum ProductInfoDialogReturnTypes {
    Added,
    Updated,
    Reschedule,
    Cancel,
    Error
}
